module.exports = __webpack_public_path__ + "img/logo-techtonic.f5d1cf6e.png";